import { FirebaseAuthTypes, signInWithPhoneNumber as signInWithPhoneNumberMobile } from '@react-native-firebase/auth';
import axios from 'axios';
import {
  Auth,
  ConfirmationResult,
  RecaptchaVerifier,
  signInWithPhoneNumber as signInWithPhoneNumberWeb
} from 'firebase/auth';
import { Platform } from 'react-native';

import { API_URL } from '@/constants/config';
import { auth } from '@/firebaseConfig';

import { client } from '..';
import { SignWithEmailResponse } from '../models/authModels';

export const signInPhoneNumber = async ({
  phoneNumber,
  captchaTag
}: {
  phoneNumber: string;
  captchaTag?: string;
}): Promise<FirebaseAuthTypes.ConfirmationResult | ConfirmationResult> => {
  if (Platform.OS !== 'web') {
    return signInWithPhoneNumberMobile(auth() as FirebaseAuthTypes.Module, phoneNumber);
  }

  return signInWithPhoneNumberWeb(
    auth() as Auth,
    phoneNumber,
    new RecaptchaVerifier(auth() as Auth, captchaTag ?? 'recaptcha-container')
  );
};

export const signInWithEmail = async (email: string): Promise<SignWithEmailResponse> => {
  const { data } = await client.post('/auth/after-login', { email });
  return data;
};

export const deleteUser = async ({ userId }: { userId: string }): Promise<any> => {
  const url = `/users/${userId}`;

  const { data } = await client.delete(url);

  return data;
};

export const createRedirect = async (): Promise<{ token: string }> => {
  const { data } = await client.post('/auth/create-redirect');

  return data;
};

export const validateRedirect = async ({
  oneTimeToken
}: {
  oneTimeToken: string;
}): Promise<{ customFbJwt: string }> => {
  const redirectClient = axios.create({
    baseURL: API_URL,
    headers: {
      common: {
        Authorization: `Bearer ${oneTimeToken}`
      },
      'content-type': 'application/json'
    }
  });

  const { data } = await redirectClient.post('/auth/validate-redirect');

  return data;
};
